import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter-box" }
const _hoisted_2 = { class: "button-row" }

import {
  DashboardDropdownFilterComplex,
  DashboardDropdownFilterYear,
  DashboardDropdownFilterBuilding
} from '@/components/AnalyticsDashboard/components/filters'
import { ComplexProperties, BuildingProperties } from '../../types'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { ref, watch, computed, nextTick } from 'vue'
import { useStore } from 'vuex'
import { nullableSet } from '@/utils/set'
import { useI18n } from 'vue-i18n'
import { InformationResponse } from '@/api-client/models/buildingScore/Contracts'
import { FeatureType, useFilters } from '@/composables/useFilters'

type Props = {
  information: InformationResponse | undefined
  isCollapsed: boolean
}
type Emits = {
  (e: 'formSubmitted'): void
  (e: 'formReset'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardBuildingScoresFilters',
  props: {
    information: {},
    isCollapsed: { type: Boolean }
  },
  emits: ["formSubmitted", "formReset"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const vuex = useStore()
const filters = useFilters(FeatureType.BuildingScore)
const { t } = useI18n()

const htmlRef = ref<HTMLElement | null>(null)
const complexes = computed<ComplexProperties[]>(() =>
  vuex.getters.allComplexes.map((x) => x.properties)
)

function submitFilters() {
  filters.submit()
  emits('formSubmitted')
}

watch(
  () => props.information,
  (information) => {
    if (
      filters.current.year === undefined ||
      !information?.optionsWithData.years.includes(filters.current.year)
    ) {
      filters.$patch({ current: { year: information?.optionsWithData.years.at(-1) } })
      filters.submit()
    }
  }
)
watch(
  () => props.isCollapsed,
  async () => {
    await nextTick()
    htmlRef.value?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
)

function complexSelected(complex: ComplexProperties | undefined) {
  filters.$patch({
    current: {
      complex: complex,
      buildings: []
    }
  })
}
const buildings = computed<BuildingProperties[]>(() =>
  vuex.getters.allBuildings.map((x) => x.properties)
)
const filteredBuildings = computed<BuildingProperties[]>(() => {
  if (!filters.current.complex) {
    return buildings.value
  }
  const id = filters.current.complex.belongsToId
  return buildings.value.filter((x) => x.complexId === id)
})

return (_ctx: any,_cache: any) => {
  return (!_ctx.isCollapsed)
    ? (_openBlock(), _createBlock(_Transition, {
        key: 0,
        name: "slide"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              ref_key: "htmlRef",
              ref: htmlRef,
              class: "filter-container"
            }, [
              _createVNode(_unref(DashboardDropdownFilterYear), {
                years: _ctx.information?.optionsWithData.years ?? [],
                selectedYear: _unref(filters).current.year,
                onSelectionChanged: _cache[0] || (_cache[0] = (year) => _unref(filters).$patch({ current: { year } }))
              }, null, 8, ["years", "selectedYear"]),
              _createVNode(_unref(DashboardDropdownFilterComplex), {
                complexes: complexes.value,
                selectedComplex: _unref(filters).current.complex,
                optionsWithData: _unref(nullableSet)(_ctx.information?.optionsWithData?.complexes),
                onSelectionChanged: complexSelected
              }, null, 8, ["complexes", "selectedComplex", "optionsWithData"]),
              _createVNode(_unref(DashboardDropdownFilterBuilding), {
                buildings: filteredBuildings.value,
                selectedBuildings: _unref(filters).current.buildings,
                presentAsMultiSelect: !!_unref(filters).current.complex,
                optionsWithData: _unref(nullableSet)(_ctx.information?.optionsWithData?.constructions),
                onSelectionChanged: _cache[1] || (_cache[1] = (buildings) => _unref(filters).$patch({ current: { buildings } }))
              }, null, 8, ["buildings", "selectedBuildings", "presentAsMultiSelect", "optionsWithData"])
            ], 512),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ButtonOutline, {
                size: "small",
                buttonText: _unref(t)('general__text__dashboard_reset_selections'),
                onOnClicked: _unref(filters).reset
              }, null, 8, ["buttonText", "onOnClicked"]),
              _createVNode(ButtonPrimary, {
                size: "small",
                disabled: 
              !_unref(filters).currentMeta.hasGeographicalFilter && _unref(filters).isCurrentFilterSubmitted
            ,
                buttonText: _unref(t)('general__text__dashboard_update_selections'),
                onOnClicked: submitFilters
              }, null, 8, ["disabled", "buttonText"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})